module.exports = __webpack_public_path__ + "img/about-section-1@2x.d1c7ade6.jpg";